"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const errors_1 = require("../../errors");
const ICondition_1 = require("../models/rates/ICondition");
const Adjustments_1 = __importDefault(require("./chargecondition/Adjustments"));
const Assemblies_1 = __importDefault(require("./chargecondition/Assemblies"));
const Receiving_1 = __importDefault(require("./chargecondition/Receiving"));
const Returns_1 = __importDefault(require("./chargecondition/Returns"));
const Shipping_1 = __importDefault(require("./chargecondition/Shipping"));
const ChargeMethodValidator_1 = __importDefault(require("./ChargeMethodValidator"));
const ChargeTierValidator_1 = __importDefault(require("./ChargeTierValidator"));
const UomChargeMethodValidator_1 = __importDefault(require("./UomChargeMethodValidator"));
class ConditionValidator {
    constructor(chargeMethodValidator, chargeTierValidator, uomChargeMethodValidator) {
        this._chargeMethodValidator = chargeMethodValidator
            ? chargeMethodValidator
            : new ChargeMethodValidator_1.default();
        this._chargeTierValidator = chargeTierValidator
            ? chargeTierValidator
            : new ChargeTierValidator_1.default();
        this._uomChargeMethodValidator = uomChargeMethodValidator
            ? uomChargeMethodValidator
            : new UomChargeMethodValidator_1.default();
        this._shippingConditionValidator = new Shipping_1.default();
        this._returnsConditionValidator = new Returns_1.default();
        this._receivingConditionValidator = new Receiving_1.default();
        this._assembliesConditionValidator = new Assemblies_1.default();
        this._adjustmentsConditionValidator =
            new Adjustments_1.default();
    }
    _schema = joi_1.default.object({
        condition: joi_1.default.object().required(),
        chargeMethod: joi_1.default.object().optional(),
        uomChargeMethod: joi_1.default.object().optional(),
        chargeTiers: joi_1.default.object().optional(),
    });
    _chargeMethodValidator;
    _uomChargeMethodValidator;
    _chargeTierValidator;
    _shippingConditionValidator;
    _returnsConditionValidator;
    _receivingConditionValidator;
    _assembliesConditionValidator;
    _adjustmentsConditionValidator;
    shipping = {
        validate: (input, jsonPath, isUomCountRate) => {
            const conditionIssues = [];
            let chargeMethodIssues = [];
            let uomChargeMethodIssues = [];
            let chargeTierIssues = [];
            let conditionFlags = {};
            conditionFlags = this.verifyRestriction(input.condition, conditionFlags);
            const schemaErrors = this._schema.validate(input, {
                abortEarly: false,
                convert: false,
            });
            conditionIssues.push(...this.schemaErrorHandler(schemaErrors, jsonPath));
            if (conditionIssues.length > 0) {
                return conditionIssues;
            }
            conditionIssues.push(...(this._shippingConditionValidator.validate(input.condition, `${jsonPath}.condition`) ?? []));
            if (isUomCountRate) {
                if (!input.uomChargeMethod) {
                    conditionIssues.push(new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.requiredValue, 'uomChargeMethod', undefined, jsonPath));
                    return conditionIssues;
                }
                uomChargeMethodIssues = this._uomChargeMethodValidator.validate(input.uomChargeMethod);
            }
            else {
                if (!input.chargeMethod) {
                    conditionIssues.push(new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.requiredValue, 'chargeMethod', undefined, jsonPath));
                    return conditionIssues;
                }
                chargeMethodIssues =
                    this._chargeMethodValidator.shipping.validate(input.chargeMethod, `${jsonPath}.chargeMethod`, conditionFlags);
            }
            if (!isUomCountRate) {
                if (!input.chargeTiers) {
                    conditionIssues.push(new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.requiredValue, 'chargeTiers', undefined, jsonPath));
                    return conditionIssues;
                }
                chargeTierIssues = this._chargeTierValidator.validate(input.chargeTiers, `${jsonPath}.chargeTiers`);
            }
            const output = [
                ...(conditionIssues ?? []),
                ...(chargeMethodIssues ?? []),
                ...(uomChargeMethodIssues ?? []),
                ...(chargeTierIssues ?? []),
            ];
            return output.length > 0 ? output : undefined;
        },
        requestNextValueSet: (conditionalField) => {
            return this._shippingConditionValidator.requestNextValueSet(conditionalField);
        },
    };
    receiving = {
        validate: (input, jsonPath, isUomCountRate) => {
            const conditionIssues = [];
            let chargeMethodIssues = [];
            let uomChargeMethodIssues = [];
            let chargeTierIssues = [];
            const schemaErrors = this._schema.validate(input, {
                abortEarly: false,
                convert: false,
            });
            conditionIssues.push(...this.schemaErrorHandler(schemaErrors, jsonPath));
            if (conditionIssues.length > 0) {
                return conditionIssues;
            }
            conditionIssues.push(...(this._receivingConditionValidator.validate(input.condition, `${jsonPath}.condition`) ?? []));
            if (isUomCountRate) {
                if (!input.uomChargeMethod) {
                    conditionIssues.push(new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.requiredValue, 'uomChargeMethod', undefined, jsonPath));
                    return conditionIssues;
                }
                uomChargeMethodIssues = this._uomChargeMethodValidator.validate(input.uomChargeMethod);
            }
            else {
                if (!input.chargeMethod) {
                    conditionIssues.push(new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.requiredValue, 'chargeMethod', undefined, jsonPath));
                    return conditionIssues;
                }
                chargeMethodIssues =
                    this._chargeMethodValidator.receiving.validate(input.chargeMethod, `${jsonPath}.chargeMethod`);
            }
            if (!isUomCountRate) {
                if (!input.chargeTiers) {
                    conditionIssues.push(new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.requiredValue, 'chargeTiers', undefined, jsonPath));
                    return conditionIssues;
                }
                chargeTierIssues = this._chargeTierValidator.validate(input.chargeTiers, `${jsonPath}.chargeTiers`);
            }
            const output = [
                ...(conditionIssues ?? []),
                ...(chargeMethodIssues ?? []),
                ...(uomChargeMethodIssues ?? []),
                ...(chargeTierIssues ?? []),
            ];
            return output.length > 0 ? output : undefined;
        },
        requestNextValueSet: (conditionalField) => {
            return this._receivingConditionValidator.requestNextValueSet(conditionalField);
        },
    };
    returns = {
        validate: (input, jsonPath, isUomCountRate) => {
            const conditionIssues = [];
            let chargeMethodIssues = [];
            let uomChargeMethodIssues = [];
            let chargeTierIssues = [];
            const schemaErrors = this._schema.validate(input, {
                abortEarly: false,
                convert: false,
            });
            conditionIssues.push(...this.schemaErrorHandler(schemaErrors, jsonPath));
            if (conditionIssues.length > 0) {
                return conditionIssues;
            }
            conditionIssues.push(...(this._returnsConditionValidator.validate(input.condition, `${jsonPath}.condition`) ?? []));
            if (isUomCountRate) {
                if (!input.uomChargeMethod) {
                    conditionIssues.push(new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.requiredValue, 'uomChargeMethod', undefined, jsonPath));
                    return conditionIssues;
                }
                uomChargeMethodIssues = this._uomChargeMethodValidator.validate(input.uomChargeMethod);
            }
            else {
                if (!input.chargeMethod) {
                    conditionIssues.push(new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.requiredValue, 'chargeMethod', undefined, jsonPath));
                    return conditionIssues;
                }
                chargeMethodIssues =
                    this._chargeMethodValidator.returns.validate(input.chargeMethod, `${jsonPath}.chargeMethod`);
            }
            if (!isUomCountRate) {
                if (!input.chargeTiers) {
                    conditionIssues.push(new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.requiredValue, 'chargeTiers', undefined, jsonPath));
                    return conditionIssues;
                }
                chargeTierIssues = this._chargeTierValidator.validate(input.chargeTiers, `${jsonPath}.chargeTiers`);
            }
            const output = [
                ...(conditionIssues ?? []),
                ...(chargeMethodIssues ?? []),
                ...(uomChargeMethodIssues ?? []),
                ...(chargeTierIssues ?? []),
            ];
            return output.length > 0 ? output : undefined;
        },
        requestNextValueSet: (conditionalField) => {
            return this._returnsConditionValidator.requestNextValueSet(conditionalField);
        },
    };
    adjustments = {
        validate: (input, jsonPath, isUomCountRate) => {
            const conditionIssues = [];
            let chargeMethodIssues = [];
            let uomChargeMethodIssues = [];
            let chargeTierIssues = [];
            const schemaErrors = this._schema.validate(input, {
                abortEarly: false,
                convert: false,
            });
            conditionIssues.push(...this.schemaErrorHandler(schemaErrors, jsonPath));
            if (conditionIssues.length > 0) {
                return conditionIssues;
            }
            conditionIssues.push(...(this._adjustmentsConditionValidator.validate(input.condition, `${jsonPath}.condition`) ?? []));
            if (isUomCountRate) {
                if (!input.uomChargeMethod) {
                    conditionIssues.push(new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.requiredValue, 'uomChargeMethod', undefined, jsonPath));
                    return conditionIssues;
                }
                uomChargeMethodIssues = this._uomChargeMethodValidator.validate(input.uomChargeMethod);
            }
            else {
                if (!input.chargeMethod) {
                    conditionIssues.push(new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.requiredValue, 'chargeMethod', undefined, jsonPath));
                    return conditionIssues;
                }
                chargeMethodIssues =
                    this._chargeMethodValidator.adjustments.validate(input.chargeMethod, `${jsonPath}.chargeMethod`);
            }
            if (!isUomCountRate) {
                if (!input.chargeTiers) {
                    conditionIssues.push(new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.requiredValue, 'chargeTiers', undefined, jsonPath));
                    return conditionIssues;
                }
                chargeTierIssues = this._chargeTierValidator.validate(input.chargeTiers, `${jsonPath}.chargeTiers`);
            }
            const output = [
                ...(conditionIssues ?? []),
                ...(chargeMethodIssues ?? []),
                ...(uomChargeMethodIssues ?? []),
                ...(chargeTierIssues ?? []),
            ];
            return output.length > 0 ? output : undefined;
        },
        requestNextValueSet: (conditionalField) => {
            return this._adjustmentsConditionValidator.requestNextValueSet(conditionalField);
        },
    };
    assemblies = {
        validate: (input, jsonPath, isUomCountRate) => {
            const conditionIssues = [];
            let chargeMethodIssues = [];
            let uomChargeMethodIssues = [];
            let chargeTierIssues = [];
            const schemaErrors = this._schema.validate(input, {
                abortEarly: false,
                convert: false,
            });
            conditionIssues.push(...this.schemaErrorHandler(schemaErrors, jsonPath));
            if (conditionIssues.length > 0) {
                return conditionIssues;
            }
            conditionIssues.push(...(this._assembliesConditionValidator.validate(input.condition, `${jsonPath}.condition`) ?? []));
            if (isUomCountRate) {
                if (!input.uomChargeMethod) {
                    conditionIssues.push(new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.requiredValue, 'uomChargeMethod', undefined, jsonPath));
                    return conditionIssues;
                }
                uomChargeMethodIssues = this._uomChargeMethodValidator.validate(input.uomChargeMethod);
            }
            else {
                if (!input.chargeMethod) {
                    conditionIssues.push(new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.requiredValue, 'chargeMethod', undefined, jsonPath));
                    return conditionIssues;
                }
                chargeMethodIssues =
                    this._chargeMethodValidator.assemblies.validate(input.chargeMethod, `${jsonPath}.chargeMethod`);
            }
            if (!isUomCountRate) {
                if (!input.chargeTiers) {
                    conditionIssues.push(new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.requiredValue, 'chargeTiers', undefined, jsonPath));
                    return conditionIssues;
                }
                chargeTierIssues = this._chargeTierValidator.validate(input.chargeTiers, `${jsonPath}.chargeTiers`);
            }
            const output = [
                ...(conditionIssues ?? []),
                ...(chargeMethodIssues ?? []),
                ...(uomChargeMethodIssues ?? []),
                ...(chargeTierIssues ?? []),
            ];
            return output.length > 0 ? output : undefined;
        },
        requestNextValueSet: (conditionalField) => {
            return this._assembliesConditionValidator.requestNextValueSet(conditionalField);
        },
    };
    schemaErrorHandler(result, jsonPath) {
        const issues = [];
        if (result.error) {
            result.error.details.forEach((issue) => {
                switch (issue.type) {
                    case 'any.only': {
                        issues.push(new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.invalidValue, issue.context?.key, issue.context?.value, jsonPath));
                        break;
                    }
                    case 'any.required': {
                        issues.push(new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.requiredValue, issue.context?.key, undefined, jsonPath));
                        break;
                    }
                    case 'object.unknown': {
                        issues.push(new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.notAllowed, issue.context?.key, issue.context?.value, jsonPath));
                        break;
                    }
                    case 'object.base': {
                        issues.push(new errors_1.Errors.ValidationIssue('ICondition', errors_1.Errors.ValidationErrorCode.invalidType, undefined, issue.context?.value, jsonPath));
                        break;
                    }
                }
            });
        }
        return issues;
    }
    verifyRestriction(input, conditionFlags) {
        if (input?.opType === ICondition_1.DataOperatorType.logicOperator) {
            const { operands } = input;
            let previousOperandConditionFlags = conditionFlags;
            for (const operand of operands) {
                previousOperandConditionFlags = this.verifyRestriction(operand, previousOperandConditionFlags);
            }
            return previousOperandConditionFlags;
        }
        else if (input?.opType === ICondition_1.DataOperatorType.eventOperator) {
            const { conditionalField } = input;
            if (conditionalField === ICondition_1.EventOpConditionalField.muType) {
                conditionFlags.isMUTypeRestricted = true;
            }
        }
        return conditionFlags;
    }
}
exports.default = ConditionValidator;
